import { TAvailableConfigValues } from '@customTypes/common';

export interface IBufferControllerConfig {
  checkMetricsInterval: number;
  bufferStallThreshold: number;
  maxBackBufferAmount: number;
  bufferEdgeThreshold: number;
  endOfRangeThreshold: number;
  nudgePlaybackAmount: number;
  numberOfCandidatesToDetectGap: number;
  numberOfFragmentToKeep: 2;
  recreateSourceBufferOnResolutionChange: boolean;
  saveLastSegmentsCount: number;
  sourceBufferStuckTimeout: number;
  timeSyncResyncInterval: number;
  timeSyncUrlTemplate: string;
  enableG2GLatencyMeasurement: boolean;
}

export const defaultBufferControllerConfig: IBufferControllerConfig = {
  checkMetricsInterval: 150,
  bufferStallThreshold: 0.2,
  maxBackBufferAmount: 10000,
  bufferEdgeThreshold: 0.3,
  endOfRangeThreshold: 0.4,
  nudgePlaybackAmount: 0.1,
  numberOfCandidatesToDetectGap: 2,
  numberOfFragmentToKeep: 2,
  recreateSourceBufferOnResolutionChange: false,
  saveLastSegmentsCount: 3,
  sourceBufferStuckTimeout: 1000,
  timeSyncResyncInterval: -1,
  enableG2GLatencyMeasurement: false,
  timeSyncUrlTemplate: '//time.{{domain}}/time',
};

export const availableBufferControllerConfigValues: TAvailableConfigValues<IBufferControllerConfig> = {};
